import { DaumPostcodeEmbed, DaumPostcodeEmbedProps } from 'react-daum-postcode'

function AddressBox ( props: AddressBoxProps ) {
    const { ...rest } = props

    return (
        <DaumPostcodeEmbed
            { ...rest }
            style={{
                width: '100%',
                height: '100%'
            }}
        />
    )
}


export default AddressBox

interface AddressBoxProps extends DaumPostcodeEmbedProps {

}